import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { TutorialWizardComponent } from '../../../../ui/tutorial-wizard/tutorial-wizard/tutorial-wizard.component';
import { TutorialWizardSlideDirective } from '../../../../ui/tutorial-wizard/tutorial-wizard-slide.directive';
import { TutorialSlideContentComponent } from '../../../../ui/tutorial-wizard/tutorial-slide-content/tutorial-slide-content.component';
import { TutorialVersusContentComponent } from '../../../../ui/tutorial-wizard/tutorial-versus-content/tutorial-versus-content.component';
import { GameTutorial } from '../game-tutorial';
import { imageAssetPath } from 'src/app/core/services/theme/theme-asset-path';

@Component({
  selector: 'app-twentyone-tutorial',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TutorialWizardComponent,
    TutorialWizardSlideDirective,
    TutorialSlideContentComponent,
    TutorialVersusContentComponent,
  ],
  template: `
    <app-tutorial-wizard [totalPages]="3" [slideTitles]="slideTitles">
      <div appTutorialSlide>
        <app-tutorial-slide-content
          [imageUrl]="img('twentyone-tutorial-1.png')"
          [description]="t('twentyone-slide-1')"
        />
      </div>

      <div appTutorialSlide>
        <app-tutorial-slide-content
          [imageUrl]="img('twentyone-tutorial-2.png')"
          [description]="t('twentyone-slide-2')"
        />
      </div>

      <div appTutorialSlide>
        <app-tutorial-versus-content
          [imageUrl]="img('twentyone-tutorial-3.png')"
          [description]="t('twentyone-slide-3')"
          labelBottom="4%"
        />
      </div>
    </app-tutorial-wizard>
  `,
  styles: [],
})
export class TwentyOneTutorialComponent implements GameTutorial {
  private translocoService = inject(TranslocoService);
  private themeService = inject(ThemeService);

  readonly slideTitles = [this.t('how-to-play'), this.t('how-to-win'), this.t('real-opponents')];

  t(key: string): string {
    return this.translocoService.translate(`components.tutorial-wizard.${key}`);
  }

  img(name: string): string | null {
    return this.themeService.assetUrl(imageAssetPath(name));
  }
}
